import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import { useUserToken } from "./UserTokenContext";
import ActivityBoardService from "../services/ActivityBoardService";
const ActivityContext = createContext();

export const ActivityProvider = ({ children }) => {
  const { account, webPhone, email, userID, userToken } = useUserToken();
  const [extensions, setExtensions] = useState(null);
  const [formattedExtensions, setFormattedExtensions] = useState([]);
  const extensionsRef = useRef([]);
  const [myObject, setMyObject] = useState({
    RING: [],
    INBOUND: [],
    OUTBOUND: [],
    EXTENSION: [],
  });
  // console.log("myObject -->", myObject);
  const [contextTest, setContextTest] = useState();

  // useEffect(() => {
  //   if (userToken) {
  //     ActivityBoardService.getExtensions({
  //       userid: userID,
  //       token: userToken,
  //       accountcode: account.acc_accountcode,
  //     })
  //       .then((response) => {
  //         setExtensions(response.data.Response.Extension);
  //       })
  //       .catch((error) => console.log("error -->", error));
  //   }
  // }, [userToken]);

  const removeFromAllKeys = (linkedidNo) => {
    setMyObject((prevState) => {
      const updatedState = { ...prevState };

      // Tüm keyleri dolaşarak extensionNo'ya göre filtrele
      Object.keys(updatedState).forEach((key) => {
        updatedState[key] = updatedState[key].filter(
          (item) => item.linkedid !== linkedidNo
        );
      });
      // console.log("updatedState -->", updatedState);

      return updatedState;
    });
  };

  const findSocketStatusColor = (extensionNo) => {

    // `myObject.RING` içinde `arayan` veya `aranan` değerlerinde eşleşme kontrolü

    const isRingMatching = myObject.RING.some(
      (ringItem) =>
        ringItem.arayan === extensionNo ||
        ringItem.aranan === extensionNo ||
        // ringItem.arayan.split("-")[0] === extensionNo ||
        ringItem.arayandahili.split("-")[0] === extensionNo
    );

    // `myObject.INBOUND` içinde `arayan` veya `aranan` değerlerinde eşleşme kontrolü
    const isInboundMatching = myObject.INBOUND.some(
      (inboundItem) => inboundItem.aranan === extensionNo
    );

    // isInboundMatching && console.log("isInboundMatching -->", isInboundMatching);

    const isOutboundMatching = myObject.OUTBOUND.some(
      (outboundItem) =>
        outboundItem.arayandahili.split("-")[0] === extensionNo ||
        outboundItem.arayan.split("-")[0] === extensionNo
    );

    // isOutboundMatching && console.log("isOutboundMatching -->", isOutboundMatching);

    const isExtensionMatching = myObject.EXTENSION.some(
      (inboundItem) =>
        inboundItem.arayan.split("-")[0] === extensionNo ||
        inboundItem.aranan === extensionNo
    );

    // isExtensionMatching && console.log("isExtensionMatching -->", isExtensionMatching);

    // Öncelik sırasıyla uygun durumu döndür
    if (isRingMatching) {
      return "bg-warning"; // Eğer RING içinde varsa
    } else if (isInboundMatching) {
      return "bg-success"; // Eğer INBOUND içinde varsa
    } else if (isOutboundMatching) {
      return "bg-info";
    } else if (isExtensionMatching) {
      return "bg-dark";
    }

    return ""; // Hiçbir eşleşme yoksa boş string döner
  };

  const checkIfAnswered = (extensionNo) => {
    return Object.keys(myObject).some((key) => {
      return myObject[key].some(
        (item) =>
          (item.arayandahili.split("-")[0] === extensionNo ||
            item.aranan === extensionNo ||
            item.arayan.split("-")[0] === extensionNo) &&
          item.tipi === "ANSWERED"
      );
    });
  };

  useEffect(() => {
    if (extensions) {
      const formatted = extensions.map((extension) => ({
        id: extension.name,
        extensionNo: extension.name.split("-")[0],
        name: extension.usr_title,
        status: parseInt(extension.lastms) > -1 ? "online" : "offline",
        phoneType: extension.usr_phone_type,
        socketStatus: findSocketStatusColor(extension.name.split("-")[0]),
        callStatus: checkIfAnswered(extension.name.split("-")[0]),
      }));
      extensionsRef.current = formatted;
      setFormattedExtensions(formatted);
    }
  }, [extensions, myObject]);

  const handleRingFilter = (data) => {
    // console.log("debug10", data);

    const extensionNo = data?.arayandahili?.split("-")[0];
    const extensionOutbound = extensionsRef.current.some(
      (item) => item.extensionNo === extensionNo
    );
    const testOne = extensionsRef.current.some(
      (item) => item.extensionNo === data?.arayan?.split("-")[0]
    );
    const testTwo = extensionsRef.current.some(
      (item) => item.extensionNo === data.aranan
    );

    if (extensionOutbound) {
      return "extension-outbound";
    } else if (testOne && testTwo) {
      return "extension-call";
    } else if (testTwo) {
      return "extension-inbound";
    }
    return "";
  };

  const addToKey = (key, newObject) => {
    setMyObject((prevState) => ({
      ...prevState,
      [key]: [...prevState[key], newObject],
    }));
  };

  const handleIncludes = (data) => {
    if (extensionsRef.current.length > 0) {
      const arayan =
        typeof data.arayan === "string" && data.arayan.includes("-")
          ? data.arayan.split("-")[0]
          : data.arayan;

      const aranan = data.aranan;

      const arayanDahili = data.arayandahili;

      const inbountCall = extensionsRef.current.some(
        (item) => item.extensionNo === aranan
      );
      const outbountCall = extensionsRef.current.some(
        (item) =>
          item.extensionNo === arayan ||
          item.extensionNo === arayanDahili.split("-")[0]
      );

      // console.log("inbountCall -->", inbountCall);
      // console.log("outbountCall -->", outbountCall);

      if (inbountCall && outbountCall) {
        return "extension";
      } else if (inbountCall) {
        return "inbound";
      } else if (outbountCall) {
        return "outbound";
      }
    }
  };

  const handleFilter = (data) => {
    // console.log("ACTIVITYBOARD -->", data);
    // console.log("debug9");

    if (data.tipi === "RING") {
      // console.log("debug1");

      removeFromAllKeys(data.linkedid);
      // removeFromKey("RING", data.linkedid);
      const test = handleRingFilter(data);

      if (test === "extension-outbound") {
        addToKey("OUTBOUND", data);
      } else if (test === "extension-call") {
        addToKey("OUTBOUND", data);
        addToKey("RING", data);
      } else if (test === "extension-inbound") {
        addToKey("RING", data);
      }
      // addToKey("RING")
    } else if (data.tipi === "ANSWERED") {
      // console.log("debug4");
      const test = handleIncludes(data);
      // console.log("test -->", test);

      if (test === "inbound") {
        // removeFromKey("RING", data.aranan);
        removeFromAllKeys(data.linkedid);
        addToKey("INBOUND", data);
      } else if (test === "outbound") {
        // console.log("debug6");
        removeFromAllKeys(data.linkedid);
        // removeFromKey("RING", data.aranan);
        addToKey("OUTBOUND", data);
      } else if (test === "extension") {
        // console.log("debug7");
        // removeFromKey("RING", data.aranan);
        removeFromAllKeys(data.linkedid);
        addToKey("EXTENSION", data);
      }
    } else if (data.tipi === "HANGUP") {
      // console.log("debug8");
      removeFromAllKeys(data.linkedid);
    }
  };

  useEffect(() => {
    if (contextTest) {
      handleFilter(contextTest);
    }

    // Cleanup on component unmount
  }, [contextTest]);

  const value = {
    myObject,
    setMyObject,
    extensionsRef,
    contextTest,
    setContextTest,
    formattedExtensions
  };

  return (
    <ActivityContext.Provider value={value}>
      {children}
    </ActivityContext.Provider>
  );
};

export const useActivity = () => useContext(ActivityContext);
